export const LOAD_BLOCKCHAIN = "LOAD_BLOCKCHAIN";
export const BLOCKCHAIN_ERROR = "BLOCKCHAIN_ERROR";
export const LOAD_USER = "LOAD_USER";
export const LOAD_USER_ERROR = "LOAD_USER_ERROR";
export const SET_STAKE_OR_UNSTAKE_AMOUNT = "SET_STAKE_OR_UNSTAKE_AMOUNT";
export const BLOCKCHAIN_ACTION = "BLOCKCHAIN_ACTION";
export const LOAD_WALLET_ADDRESS = "LOAD_WALLET_ADDRESS";

export const LOAD_WEB3_PROVIDER = "LOAD_WEB3_PROVIDER";
